import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache) {
  const _component_cookies_h1 = _resolveComponent("cookies-h1")
  const _component_cookies_p = _resolveComponent("cookies-p")
  const _component_dial_component = _resolveComponent("dial-component")
  const _component_cookies_button = _resolveComponent("cookies-button")
  const _component_cookies_panel = _resolveComponent("cookies-panel")

  return (_openBlock(), _createBlock(_component_cookies_panel, null, {
    default: _withCtx(() => [
      _createVNode(_component_cookies_h1, null, {
        default: _withCtx(() => [
          _createTextVNode(" Vault ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_cookies_p, null, {
        default: _withCtx(() => [
          _createTextVNode(" Trouvez la bonne combinaison en tournant les cadrans tout en écoutant le bruit du coffre. ")
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("audio", { src: "sounds/click1.mp3" }),
      _createElementVNode("audio", { src: "sounds/click2.mp3" }),
      _createElementVNode("audio", { src: "sounds/click3.mp3" }),
      _createElementVNode("audio", { src: "sounds/click4.mp3" }),
      _createElementVNode("div", { class: "playground" }, [
        _createVNode(_component_dial_component, {
          id: "dial1",
          "dial-id": "1"
        }),
        _createVNode(_component_dial_component, {
          id: "dial2",
          "dial-id": "2"
        }),
        _createVNode(_component_dial_component, {
          id: "dial3",
          "dial-id": "3"
        }),
        _createVNode(_component_dial_component, {
          id: "dial4",
          "dial-id": "4"
        })
      ]),
      (_ctx.win)
        ? (_openBlock(), _createElementBlock("div", { key: 0 }, [
            _createVNode(_component_cookies_p, { style: {"text-align":"center"} }, {
              default: _withCtx(() => [
                _createTextVNode(" 🎉 C'est gagné pour aujourd'hui ! 🥳 "),
                _createElementVNode("br"),
                _createVNode(_component_cookies_button, {
                  title: "Copier dans le presse-papier",
                  onClick: $event => (_ctx.share())
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Partager ")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}